// components/NotificationBell.tsx
import { Badge, ConfigProvider } from "antd";
import { useState } from "react";
import { useNotification } from "src/contexts/NotificationContext";
import NotificationsPopUp from "src/layouts/HomePage/HomepageHeader/NotificationPopUp";

interface NotificationBellProps {
  setSelectedMenuItem: (item: string) => void;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ setSelectedMenuItem }) => {
  const { count } = useNotification();
  const [openNotifications, setOpenNotifications] = useState(false);

  return (
    <>
      <ConfigProvider direction="ltr">
        <Badge
          count={count}
          overflowCount={9_999}
          size="small"
          offset={[-6, 6]}
          style={{ backgroundColor: "red", marginInlineEnd: "10px" }}
        >
          <img
            src="/Icons//bell-header.svg"
            alt="bell"
            onClick={() => setOpenNotifications(prev => !prev)}
            className="bell-icon-dashboard mx-1"
            style={{ cursor: "pointer" }}
          />
        </Badge>
      </ConfigProvider>

      {openNotifications && (
        <NotificationsPopUp onClose={() => setOpenNotifications(false)} />
      )}
    </>
  );
};

export default NotificationBell;
